import { Injectable, signal, WritableSignal } from "@angular/core";
import { IActionsNavItem } from "../interfaces/actions-nav-item.interface";

@Injectable({
  providedIn: "root",
})
export class ActionsNavService {
  private state = new Map<string, Map<string, IActionsNavItem>>();
  private signals = new Map<string, WritableSignal<Map<string, IActionsNavItem>>>();

  addItem(navName: string, item: IActionsNavItem) {
    const navState = this.state.get(navName) ?? new Map<string, IActionsNavItem>();
    const itemState = navState.get(item.id) ?? {};
    const updatedItem = { ...itemState, ...item };
    navState.set(item.id, updatedItem);
    this.state.set(navName, navState);
    this.syncSignal(navName, navState);
  }

  removeItem(navName: string, itemId: string) {
    console.log(navName, itemId);
    const navState = this.state.get(navName);
    if (!navState) return;

    const itemState = navState.delete(itemId);
    if (!itemState) return;
    console.log(itemState);

    if (!navState.size) this.state.delete(navName);

    this.syncSignal(navName, navState);
  }

  getTrackedNavState(navName: string) {
    return this.getNavStateSignal(navName)();
  }

  getNavStateSignal(navName: string) {
    return this.getNavStateWriteableSignal(navName).asReadonly();
  }

  private getNavStateWriteableSignal(navName: string) {
    const existsSignal = this.signals.get(navName);
    if (existsSignal) return existsSignal;

    const navState = this.state.get(navName);

    const createdSignal = signal(navState ?? new Map<string, IActionsNavItem>());
    this.signals.set(navName, createdSignal);
    return createdSignal;
  }

  private syncSignal(navName: string, navState: Map<string, IActionsNavItem>) {
    const signal = this.getNavStateWriteableSignal(navName);
    signal.set(new Map(navState));
  }
}
